// extracted by mini-css-extract-plugin
export default {"review_card":"ReviewCard_review_card__3c8ys"};